var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.40426,
    cy: 3.40426,
    r: 3.40426,
    transform: "matrix(-1 0 0 1 15.6171 5.53192)",
    stroke: "#2D2C2B",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25537 17.3914C6.25537 16.6591 6.71567 16.006 7.40524 15.7597V15.7597C10.5141 14.6494 13.9115 14.6494 17.0204 15.7597V15.7597C17.71 16.006 18.1703 16.6591 18.1703 17.3914V18.5109C18.1703 19.5215 17.2752 20.2978 16.2748 20.1549L15.9412 20.1072C13.4682 19.7539 10.9575 19.7539 8.48442 20.1072L8.15087 20.1549C7.15044 20.2978 6.25537 19.5215 6.25537 18.5109V17.3914Z",
    stroke: "#2D2C2B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3191 12.4347C18.7964 12.4347 19.9939 11.2371 19.9939 9.75989C19.9939 8.28265 18.7964 7.08511 17.3191 7.08511",
    stroke: "#2D2C2B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2486 18.537L20.5106 18.5744C21.2967 18.6867 22 18.0768 22 17.2827V16.403C22 15.8277 21.6383 15.3145 21.0965 15.121C20.5561 14.928 20.0045 14.7777 19.4468 14.6701",
    stroke: "#2D2C2B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68088 12.4347C5.20364 12.4347 4.0061 11.2371 4.0061 9.75989C4.0061 8.28265 5.20364 7.08511 6.68088 7.08511",
    stroke: "#2D2C2B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75143 18.537L3.48935 18.5744C2.7033 18.6867 2.00003 18.0768 2.00003 17.2827V16.403C2.00003 15.8277 2.3617 15.3145 2.9035 15.121C3.44395 14.928 3.99549 14.7777 4.55322 14.6701",
    stroke: "#2D2C2B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.294760b11d941fb0871015bdfe3e5411.svg";
export { ForwardRef as ReactComponent };